import type { NewsNote } from "../types/news.types";
import type { NoteItem } from "../types/notes-api.types";

/** Maps an API item (NoteItem) to a note for the view (NewsNote). */
export function mapNoteItemToNewsNote(item: NoteItem): NewsNote {
  return {
    id: item.id,
    category: item.category,
    title: item.title,
    description: item.content,
    authorName: item.user?.full_name ?? "—",
    updatedAt: item.updated_at || item.created_at,
    is_pinned: item.is_pinned ?? false,
    createdByUserId: item.user_id,
    attachmentUrls: Array.isArray(item.attachment_url) ? item.attachment_url : [],
  };
}

export function mapNoteItemsToNewsNotes(items: NoteItem[]): NewsNote[] {
  return items.map(mapNoteItemToNewsNote);
}
